<template>
    <div>
        <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"
            :height="150" :width="150" :color="'#FFFF00'" :background-color="'#000000'" :opacity="0.5">
        </loading>

        <v-container style="max-width:100%;overflow-x:hidden;">
            <v-form>
                <v-row class="px-4 pt-2 pb-1">
                    <h2>{{ pageTitle }}</h2>
                </v-row>
                <v-col class="mt-n2 mb-3 px-4">
                    <v-btn color="warning" class="white--text" @click="backHandler">
                        <v-icon size="16" class="mr-1">mdi-arrow-left</v-icon>
                        {{ $t('button.back') }}
                    </v-btn>
                </v-col>

                <v-container id="scroll-target" class="px-4">

                    <!-- Header card with title + export buttons -->
                    <v-card flat class="recon-header-card mb-3">
                        <div class="recon-header-inner">
                            <div class="recon-title">
                                {{ $t('payrollreconciliationreport.payrollreconciliationbetweenyear') }}
                                <span>{{ $t('reportsparam.year') }} </span>
                                <span class="blue--text font-weight-bold">{{ data1.formData.year }}</span>
                                <span v-if="data1.formData.month">, {{ $t('reportsparam.month') }}
                                    <span class="blue--text font-weight-bold">{{ data1.formData.month }}</span>
                                </span>
                                <span class="text--secondary"> {{ header.payoutname1 }}</span>
                                <span class="mx-2 text--secondary">{{ $t('reportstaffenquiry.and') }}</span>
                                <span>{{ $t('reportsparam.year') }} </span>
                                <span class="blue--text font-weight-bold">{{ data2.formData.year }}</span>
                                <span v-if="data2.formData.month">, {{ $t('reportsparam.month') }}
                                    <span class="blue--text font-weight-bold">{{ data2.formData.month }}</span>
                                </span>
                                <span class="text--secondary"> {{ header.payoutname2 }}</span>
                            </div>
                            <div class="export-btns">
                                <button type="button" class="export-icon-btn export-icon-pdf" @click="printPDF" title="Export PDF">
                                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M9 13h2a2 2 0 0 1 0 4H9v-4z"/><path d="M15 13h1a2 2 0 0 1 0 4h-1"/><line x1="15" y1="17" x2="17" y2="17"/></svg>
                                    PDF
                                </button>
                                <button type="button" class="export-icon-btn export-icon-csv" @click="getCSV" title="Export CSV">
                                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><polyline points="9 15 12 18 15 15"/></svg>
                                    CSV
                                </button>
                            </div>
                        </div>
                    </v-card>

                    <!-- Data table -->
                    <v-data-table
                        :headers="tabHeader"
                        :items="detailItems"
                        class="recon-table"
                        fixed-header
                        :options="tableOpt"
                        hide-default-footer
                    >
                        <template v-slot:body>
                            <tbody>
                                <tr v-for="item in detailItems" :key="item.id" class="recon-row">
                                    <td class="col-no">{{ item.id }}</td>
                                    <td class="col-type">{{ item.payitemtypedesc }}</td>
                                    <td class="col-item link-cell" @click="viewdetails(item.payitemid)">
                                        {{ item.payitemdesc }}
                                    </td>
                                    <td class="col-amount">{{ item.amount }}</td>
                                    <td class="col-amount">{{ item.amount2 }}</td>
                                    <td class="col-amount" :class="parseFloat(item.amountVariance) > 0 ? 'variance-pos' : ''">
                                        {{ item.amountVariance }}
                                    </td>
                                    <td class="col-amount" :class="parseFloat(item.percentageVariance) > 5 ? 'variance-high' : parseFloat(item.percentageVariance) > 0 ? 'variance-pos' : ''">
                                        {{ item.percentageVariance }}
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-data-table>

                </v-container>
            </v-form>
        </v-container>
    </div>
</template>

<script>
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import Loading from "vue-loading-overlay";

export default {
    props: {
        parentObject: Object
    },

    components: {
        Loading,
    },

    data() {
        return {
            publicPath: process.env.BASE_URL,
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                }
            },

            tableOpt: {
                itemsPerPage: -1
            },

            pageTitle: this.$t('payrollreconciliationreport.payrollreconciliation'),
            
            tabHeader: [
                { text: this.$t('columns.no'), value: 'id', sortable: false, width: '5px' },
                { text: this.$t('setuppayitmetype.payitemtype'), value: 'payitemtypedesc', width: '200px', sortable: false},
                { text: this.$t('setuppayitem.payitem'), value: 'payitemdesc', width: '300px', sortable: false},
                { text: this.$t('payrollreconciliationreport.amount1'), value: 'amount', sortable: false, align: 'end'},
                { text: this.$t('payrollreconciliationreport.amount2'), value: 'amount2', sortable: false, align: 'end' },
                { text: this.$t('payrollreconciliationreport.varianceamt'), value: 'amountVariance', sortable: false, align: 'end' },
                { text: this.$t('payrollreconciliationreport.variancepercentage'), value: 'percentageVariance', sortable: false, align: 'end' },
            ],

            data1: {
                formData: {
                    month: this.$route.params.formData.month1,
                    payout: this.$route.params.formData.payout1,
                    year: this.$route.params.formData.year1,
                },
                parameters: {
                    brchid: this.$route.params.param.branchid,
                    compnyid: this.$route.params.param.companyid,
                    deptid: this.$route.params.param.departmentid,
                    emptypeid: this.$route.params.param.employmenttypeid,
                    gradeid: this.$route.params.param.gradeid,
                    staffid: this.$route.params.param.staffid,
                },
            },

            data2: {
                formData: {
                    month: this.$route.params.formData.month2,
                    payout: this.$route.params.formData.payout2,
                    year: this.$route.params.formData.year2
                },
                parameters: {
                    brchid: this.$route.params.param.branchid,
                    compnyid: this.$route.params.param.companyid,
                    deptid: this.$route.params.param.departmentid,
                    emptypeid: this.$route.params.param.employmenttypeid,
                    gradeid: this.$route.params.param.gradeid,
                    staffid: this.$route.params.param.staffid,
                },
            },

            header: {
                payoutname1: null,
                payoutname2: null
            },

            detailItems: [],
            detail1: [],
            detail2: [],
            detailtotal: [],

            amountVariance: null, 
            percentageVariance: null, 

            errMsg: '',
            title: '',

            isErr: false,
            loading: false,
        }
    },

    methods: {
        
        //go back to parameter selection page
        backHandler() {
            this.$router.push({name: 'parameterpayrollreconciliation'});
        },

        viewdetails(id) {
            let formData = {
                year1: this.data1.formData.year,
                month1: this.data1.formData.month,
                payout1: this.data1.formData.payout,
                year2: this.data2.formData.year,
                month2: this.data2.formData.month,
                payout2: this.data2.formData.payout,
            }

            let param = {
                staffid: this.data1.parameters.staffid,
                gradeid: this.data1.parameters.gradeid,
                employmenttypeid: this.data1.parameters.employmenttypeid,
                companyid: this.data1.parameters.companyid,
                branchid: this.data1.parameters.branchid,
                departmentid: this.data1.parameters.departmentid
            }
            let payitemid = id
            this.$router.push({name: 'viewdetails', params: { payitemid, formData, param  }});
        },

        loadPayoutControl1() {
            const vm = this;

            return this.$store.dispatch('get', {url: "/payoutctrl/" + vm.data1.formData.payout})
            .then((res) => {
                let payout = res.data.rec[0];
                vm.header.payoutname1 = payout.payoutdesc
            })
            .catch((err) => {
                vm.isErr = !vm.isErr;
                vm.errMsg = err;
            });
        },

        loadPayoutControl2() {
            const vm = this;

            return this.$store.dispatch('get', {url: "/payoutctrl/" + vm.data2.formData.payout})
            .then((res) => {
                let payout = res.data.rec[0];
                vm.header.payoutname2 = payout.payoutdesc
            })
            .catch((err) => {
                vm.isErr = !vm.isErr;
                vm.errMsg = err;
            });
        },

        async loadDetailListHandler1() {
            const vm = this;

            try {
                const res = await this.$store.dispatch('post', {url: `/payrollreconciliation/summary/${this.$store.getters.userId}`, payload: vm.data1})
            
                vm.detail1 = res.data.rec
                for (let i = 0; i < vm.detail1.length; i++) {
                    vm.detail1[i].amtid = 1
                    vm.detailtotal.push(vm.detail1[i])
                }
                await this.loadDetailListHandler2();
            } catch(err) {
                vm.isErr = true;
                vm.errMsg = err;
            }
            
        },

        loadDetailListHandler2() {
            const vm = this;

            return this.$store.dispatch('post', {url: `/payrollreconciliation/summary/${this.$store.getters.userId}`, payload: vm.data2})
            .then (res => {
                vm.detail2 = res.data.rec
                for (let i = 0; i < vm.detail2.length; i++) {
                    vm.detail2[i].amtid = 2
                    vm.detailtotal.push(vm.detail2[i])
                }
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
            })
            
        },

        loadAmount() {
            return new Promise((resolve) => {
                setTimeout(() => {
                    const vm = this
                    var amountSum = [];

                    for (let i = 0; i < vm.detailtotal.length; i++) {
                        vm.detailtotal[i].id = i + 1
                    }

                    vm.detailtotal.forEach(function (o) {
                        var existing = amountSum.filter(function (i) {
                        return i.payitemdesc === o.payitemdesc;
                        })[0];
                        if (!existing || existing == undefined) {
                        if (o.amtid == 1) {
                            o.amount2 = '0';
                        } else {
                            o.amount2 = o.amount
                            o.amount = '0'
                        }
                        amountSum.push(o);
                        } else {
                        existing.amount2 = o.amount;
                        }
                    });

                    amountSum.forEach(element => {
                        if (element.amount.indexOf(',') > -1) { 
                        element.amount = parseFloat(element.amount.replace(/,/g, ''))
                        } else {
                        element.amount = parseFloat(element.amount)
                        }

                        if (element.amount2.indexOf(',') > -1) { 
                        element.amount2 = parseFloat(element.amount2.replace(/,/g, ''))
                        } else {
                        element.amount2 = parseFloat(element.amount2)
                        }
                        
                        element.amountVariance = element.amount - element.amount2
                        element.amountVariance = Math.abs(element.amountVariance)

                        element.amount = element.amount.toFixed(2)
                        element.amount2 = element.amount2.toFixed(2)
                        element.amountVariance = element.amountVariance.toFixed(2)
                    });

                    amountSum.forEach(element => {
                        element.percentageVariance = (element.amountVariance/element.amount) * 100;
                        if (isNaN(element.percentageVariance)) {element.percentageVariance = 0}
                        element.percentageVariance = element.percentageVariance.toFixed(2)

                        if ((element.percentageVariance == 'Infinity' )){
                            element.percentageVariance = '100.00'
                        //   console.log('elemet', element.percentageVariance)
                        }
                    });

                    

                    vm.detailItems = amountSum
                    resolve();

                    }, 1000);
            });
        },
        
        // functions for print to pdf and export to csv
        objectToCSV(data) {
            const csvRows = []

            // get header
            const headers = Object.keys(data[0])
            csvRows.push(headers.join(','))

            // loop over the rows
            for (const row of data) {
                const values = headers.map(header => {
                    const escaped = ('' + row[header]).replace(/"/g, '\\"')
                    return `"${escaped}"`
                })
                csvRows.push(values.join(','))
            }
            return csvRows.join('\n')
        },

        download(data) {
            const blob = new Blob([decodeURIComponent('%ef%bb%bf'), data], { type: 'text/csv'})
            const url = window.URL.createObjectURL(blob)
            const a = document.createElement('a')

            a.setAttribute('hidden', '')
            a.setAttribute('href', url)
            if (this.header.payoutname1 && this.header.payoutname2) {
                a.setAttribute('download', this.$t('payrollreconciliationreport.payrollreconciliationbetweenyear')  + this.header.payoutname1 + this.$t('reportstaffenquiry.and') +  this.header.payoutname2 + '.csv')
            } else {
                a.setAttribute('download', this.$t('payrollreconciliationreport.payrollreconciliationbetweenyear') + this.data1.formData.year + '_' + this.data1.formData.month + this.$t('reportstaffenquiry.and') +  this.data2.formData.year + '_' + this.data2.formData.month + '.csv')
            }

            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        },

        async getCSV() {
            let item = this.detailItems
            let data = []

            for (var i = 0; i < item.length; i++) {
                data.push({
                    [`${this.$t('columns.no')}`]: item[i].id,
                    [`${this.$t('setuppayitmetype.payitemtype')}`]: item[i].payitemtypedesc,
                    [`${this.$t('setuppayitem.payitem')}`]: item[i].payitemdesc,
                    [`${this.$t('payrollreconciliationreport.amount1')}`]: item[i].amount,
                    [`${this.$t('payrollreconciliationreport.amount2')}`]: item[i].amount2,
                    [`${this.$t('payrollreconciliationreport.varianceamt')}`]: item[i].amountVariance,
                    [`${this.$t('payrollreconciliationreport.variancepercentage')}`]: item[i].percentageVariance,
                })
            }

            const csvData = this.objectToCSV(data)
            this.download(csvData)
        },

        
        printPDF() {
            const doc = new jsPDF({
                orientation: 'landscape'
            })
            let item = this.detailItems

            var head = [                
                { title: this.$t('columns.no'), dataKey: 'id' },
                { title: this.$t('setuppayitmetype.payitemtype'), dataKey: 'payitemtypedesc' },
                { title: this.$t('setuppayitem.payitem'), dataKey: 'payitemdesc' },
                { title: this.$t('payrollreconciliationreport.amount1'), dataKey: 'amount' },
                { title: this.$t('payrollreconciliationreport.amount2'), dataKey: 'amount2' },
                { title: this.$t('payrollreconciliationreport.varianceamt'), dataKey: 'amountVariance' },
                { title: this.$t('payrollreconciliationreport.variancepercentage'), dataKey: 'percentageVariance' },
            ]

            let body = []

            for (var i = 0; i < item.length; i++) {
                body.push({
                    id: item[i].id,
                    payitemtypedesc: item[i].payitemtypedesc,
                    payitemdesc: item[i].payitemdesc,
                    amount: item[i].amount,
                    amount2: item[i].amount2,
                    amountVariance: item[i].amountVariance,
                    percentageVariance: item[i].percentageVariance
                })
            }

            if (this.header.payoutname1 && this.header.payoutname2) {
                doc.text(this.$t('payrollreconciliationreport.payrollreconciliationbetweenyear') + this.header.payoutname1 + this.$t('reportstaffenquiry.and') +  this.header.payoutname2, 10, 10)
                doc.autoTable(head, body)
                doc.save(this.$t('payrollreconciliationreport.payrollreconciliationbetweenyear') + this.header.payoutname1 + this.$t('reportstaffenquiry.and') +  this.header.payoutname2 + '.pdf')
            } else {
                doc.text(this.$t('payrollreconciliationreport.payrollreconciliationbetweenyear') + this.data1.formData.year + '_' + this.data1.formData.month + this.$t('reportstaffenquiry.and') +  this.data2.formData.year + '_' + this.data2.formData.month, 10, 10)
                doc.autoTable(head, body)
                doc.save(this.$t('payrollreconciliationreport.payrollreconciliationbetweenyear') + this.data1.formData.year + '_' + this.data1.formData.month + this.$t('reportstaffenquiry.and') +  this.data2.formData.year + '_' + this.data2.formData.month + '.pdf')
            }
        },

    }, //end of methods

    async created() {
        this.loading = true;
        try {
            await this.loadDetailListHandler1();
            await this.loadAmount();
            await this.loadPayoutControl1();
            await this.loadPayoutControl2();
        } finally {
            this.loading = false;
        }
    }
    
}
</script>

<style scoped>
/* Header card */
.recon-header-card {
    background: #F8FAFF;
    border: 1px solid #E8EDF5;
    border-radius: 12px;
    padding: 14px 20px;
}
.recon-header-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
}
.recon-title {
    font-size: 0.95rem;
    font-weight: 500;
    color: #334155;
    line-height: 1.6;
    flex: 1;
}

/* Export buttons */
.export-btns { display: flex; gap: 8px; align-items: center; flex-shrink: 0; }
.export-icon-btn {
    display: inline-flex; align-items: center; gap: 6px;
    padding: 6px 14px; border-radius: 8px; border: none;
    font-size: 0.8rem; font-weight: 600; cursor: pointer;
    font-family: inherit; transition: all 0.15s;
}
.export-icon-pdf { background: #FEF2F2; color: #DC2626; border: 1px solid #FECACA; }
.export-icon-pdf:hover { background: #DC2626; color: #fff; }
.export-icon-csv { background: #ECFDF5; color: #059669; border: 1px solid #A7F3D0; }
.export-icon-csv:hover { background: #059669; color: #fff; }

/* Table */
.recon-table { border-radius: 8px; overflow: hidden; }
.col-no   { width: 60px; padding-left: 16px !important; color: #94A3B8; font-size: 0.82rem; }
.col-type { font-size: 0.85rem; color: #64748B; }
.col-item { font-size: 0.88rem; font-weight: 500; }
.col-amount {
    text-align: right !important;
    padding-right: 24px !important;
    font-size: 0.88rem;
    font-family: inherit;
}

/* Clickable pay item */
.link-cell {
    cursor: pointer;
    color: #2563EB;
    text-decoration: underline dotted;
}
.link-cell:hover { color: #1D4ED8; }

/* Variance colours */
.variance-pos { color: #D97706 !important; font-weight: 600; }
.variance-high { color: #DC2626 !important; font-weight: 700; }
</style>